/* eslint-disable camelcase */
import { TFilterOptions } from '@evinced-private/ui-common';

import omit from 'lodash-es/omit';
import { IWfaSessionsFilterOption } from 'src/common/helpers/DataFilterHelper';
import { QueryVariablesBuilder } from 'src/common/helpers/GQLRequestsHelper/QueryVariablesBuilder';
import {
	ConditionOperators,
	PagesTextSearchFields,
	Wfa_Session_RunsTextSearchFields
} from 'src/common/types/graphql.generated';

import { WfaUsageDataQueryVariables } from '../WfaUsageData.generated';

const DAYS_AMOUNT_FILTER_PARAM_KEY = 'daysAmountFilter';
const DAYS_AMOUNT_X2_FILTER_PARAM_KEY = 'daysAmountx2Filter';
const CREATED_BY_FILTER_PARAM_KEY = 'createdByFilter';
const CUSTOM_FIELDS_FILTER_PARAM_KEY = 'customFieldsFilter';

const sessionsSearchFields = [Wfa_Session_RunsTextSearchFields.SessionName];

export const buildWfaUsageDataVariables = (
	filters: IWfaSessionsFilterOption
): WfaUsageDataQueryVariables => {
	const variablesBuilder = new QueryVariablesBuilder<WfaUsageDataQueryVariables>({
		searchFields: sessionsSearchFields
	});

	const { searchValue, sessionsPeriod, createdBy } = filters;
	const sessionsSinglePeriod = sessionsPeriod?.[0];

	// omit all the know filter keys.
	// this will leave us with the dynamic filter keys - the ones configured in the CC for labels
	const dynamicFilterOptions: TFilterOptions = omit(filters ?? {}, [
		'createdBy',
		'sessionsPeriod',
		'searchValue'
	]);

	variablesBuilder
		.addTextSearchParam(searchValue ?? '')
		.addFilterParam(CREATED_BY_FILTER_PARAM_KEY, createdBy)
		.addTupleFilterParam(
			CUSTOM_FIELDS_FILTER_PARAM_KEY,
			dynamicFilterOptions,
			ConditionOperators.All
		);

	if (
		sessionsSinglePeriod?.value &&
		sessionsSinglePeriod.value !== 'all' &&
		typeof sessionsSinglePeriod.value === 'number'
	) {
		variablesBuilder
			.addConditionParam(DAYS_AMOUNT_FILTER_PARAM_KEY, sessionsSinglePeriod.value)
			.addConditionParam(DAYS_AMOUNT_X2_FILTER_PARAM_KEY, 2 * sessionsSinglePeriod.value);
	}

	const variables = variablesBuilder.getVariables();

	return variables.textSearch
		? {
				...variables,
				textSearchPages: {
					...variables.textSearch,
					searchFields: [PagesTextSearchFields.SessionName]
				}
			}
		: variables;
};
